/**
 * 匠人收入 接口的统一出口
 */
import axios from '.././http' // 导入http中创建的axios实例
import qs from 'qs' // 根据需求是否导入qs模块，把请求字段直接映射过来

// 接口请求地址
const api = '/c-api/'

const tradmoney = {
    /** ***********普通用户BEGIN***************/
    // 列表
    list(params) {
        return axios.get(api + 'tradmoney/list', { params: params })
    },
    detail(params) {
        return axios.get(api + 'tradmoney/detail', { params: params })
    },
    //提现
    txstatus(params) {
        return axios.post(api + 'tradmoney/txstatus', qs.stringify(params))
    },
    // 修改比例
    getorderbili(params) {
        return axios.get(api + 'tradmoney/getorderbili', { params: params })
    },
    updorderbili(params) {
        return axios.post(api + 'tradmoney/updorderbili', qs.stringify(params))
    },
}

// 导出接口
export default tradmoney
